import axios from '../../plugins/axios'

/**
 * Acciones para el módulo OVE (Oportunidades de Venta de Equipos)
 */

export const listOveAll = (_, data) => {
  const params = new URLSearchParams()
  params.append('page', data.page || 1)

  if (data.estado && data.estado !== 'Todas') {
    params.append('estado', data.estado)
  }

  if (data.search) {
    params.append('search', data.search)
  }

  if (data.ordering) {
    params.append('ordering', data.ordering)
  }

  const apiAddress = `api/ove/listar-oves/?${params.toString()}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    // Si el backend no devuelve paginación (como en listar_oves actual),
    // simulamos el objeto de paginación para mantener consistencia con ListOVE.vue legacy
    if (Array.isArray(response.data)) {
      return {
        results: response.data,
        count: response.data.length,
      }
    }
    return response.data
  })
}

export const getEstadosOVE = ({}) => {
  const apiAddress = `api/ove/get-estados-ove/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    return response.data
  })
}

export const getOveDetail = ({ commit }, oveId) => {
  const apiAddress = `api/ove/detalle-ove/${oveId}/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    commit('SET_OVE_DETAIL', { oveDetail: response.data })
    return response.data
  })
}

export const createOve = (_, data) => {
  const apiAddress = `api/ove/crear-ove/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const listEquiposDisponibles = (_, search = '') => {
  const apiAddress = `api/ove/equipos-disponibles/?search=${search}&limit=5`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response.data)
}
export const reenviarCotizacion = ({ commit }, oveId) => {
  const apiAddress = `api/ove/reenviar-cotizacion/${oveId}/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, {}, config).then((response) => {
    commit('SET_OVE_DETAIL', { oveDetail: response.data })
    return response.data
  })
}
export const getOveActions = ({ commit }, oveId) => {
  const apiAddress = `api/ove/get-ove-actions/${oveId}/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    commit('SET_OVE_ACTIONS', { oveActions: response.data })
    return response.data
  })
}

export const recalcularOve = ({ commit }, oveId) => {
  const apiAddress = `api/ove/recalcular-totales/${oveId}/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, {}, config).then((response) => {
    commit('SET_OVE_DETAIL', { oveDetail: response.data })
    return response.data
  })
}

export const listGarantiasDisponibles = ({}) => {
  const apiAddress = `api/ove/garantias-disponibles/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response.data)
}

export const verificarStock = ({}, oveId) => {
  const apiAddress = `api/ove/verificar-stock-ove/${oveId}/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response.data)
}

export const confirmarPagoCenter = ({}, data) => {
  const apiAddress = `api/ove/confirmar-pago-center/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response.data)
}

export const editarOve = ({}, { id, data }) => {
  const apiAddress = `api/ove/editar-ove/${id}/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.patch(apiAddress, data, config).then((response) => response.data)
}

export const rechazarOve = ({ commit }, data) => {
  const apiAddress = `api/ove/rechazar-ove/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => {
    commit('SET_OVE_DETAIL', { oveDetail: response.data })
    return response.data
  })
}

export const reactivarOve = ({}, data) => {
  const apiAddress = `api/ove/reactivar-ove/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response.data)
}
